import { useEffect } from "react";
import UserCommentArea from "components/workflows/UserCommentArea.component";
import translate from "components/translations/translations.wrapper";
import { DOCUMENT_TYPE, MODAL_ACTIONS, MODAL_SEVERITY } from "utils/constants";
import { ActivateWorkflowProps } from "types/activateWorkflow";
import { useModalContext } from "components/modals/ModalContext";

export function ActivateWorkflow(props: ActivateWorkflowProps) {
    const modalContext = useModalContext();
    const toggleModal = modalContext?.toggleModal;

    const computeActivateMessage = function() {
        if(props.activate && props.replaceActiveRuleName)
            return props.translate("workflowDetails.confirmDialog.activateMessageReplace", props.ruleName, props.replaceActiveRuleName);
        if(props.activate)
            return props.translate("workflowDetails.confirmDialog.activateMessage", props.translate("documentTypes." + DOCUMENT_TYPE.asString(props.documentType)));
        else
            return props.translate("workflowDetails.confirmDialog.deactivateMessage", props.translate("documentTypes." + DOCUMENT_TYPE.asString(props.documentType)))
    }

    useEffect(() => {
        toggleModal?.(MODAL_ACTIONS.CONFIRM_ACTION, {
            title: props.activate
                ? props.translate("workflowDetails.confirmDialog.activateTitle", props.ruleName)
                : props.translate("workflowDetails.confirmDialog.deactivateTitle", props.ruleName),
            description: computeActivateMessage(),
            confirmButtonText: "popUp.yes",
            cancelButtonText: "popUp.no",
            severity: MODAL_SEVERITY.INFORMATION,
            handleAction: () => {
                toggleModal?.(null);
                props.onActivate();
            },
            closeCallback: () => props.onCancel(),
            moreContent: (
                <UserCommentArea
                    inputMessage={props.translate("workflowDetails.confirmDialog.describeChanges")}
                    moreInfo={props.translate("workflowDetails.confirmDialog.moreInfo")}
                    userInput={props.activateUserInputRef}
                />
            ),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: open once on mount
    }, []);

    return null;
}

const withTranslations = translate(ActivateWorkflow);
export default withTranslations;